import React from 'react'
import MaterialSymbol from '../material-symbol'

const MarkunreadMailbox = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="markunread_mailbox" {...props} />
))

MarkunreadMailbox.displayName = 'MarkunreadMailbox'

export default MarkunreadMailbox
